const ON_CLICK = 'on-click'
const ON_DISPLAY = 'on-display'
const ON_CONTENT = 'on-content'
const ON_VIEWMORE = 'on-viewmore'
const ON_NAVIGATION = 'on-navigation'
const ON_MOVETAB = 'on-movetab'
const EVENT_LIST = 'eventlist'
const ON_ZZIM = 'on-zzim'
const OFF_ZZIM = 'off-zzim'
const ON_INSTANTPLAY = 'on-instantplay'
const ON_DETAIL = 'on-detail'
const FLUSH_EVENT = 'flush-event'
export {
  ON_CLICK,
  ON_DISPLAY,
  ON_CONTENT,
  ON_VIEWMORE,
  ON_NAVIGATION,
  ON_MOVETAB,
  EVENT_LIST,
  ON_ZZIM,
  OFF_ZZIM,
  ON_INSTANTPLAY,
  ON_DETAIL,
  FLUSH_EVENT,
}

// event type for new with pc version synchronized
export const EVENT_TYPE = {
  ON_CLICK: 'on-click',
  ON_CONTENT: 'on-content',
  ON_DISPLAY: 'on-display',
  ON_VIEW_MORE: 'on-viewmore',
  ON_NAVIGATION: 'on-navigation',
  ON_DETAIL: 'on-detail',
  ON_MOVE_TAB: 'on-movetab',
  ON_INSTANT_PLAY: 'on-instantplay',
  ON_ZZIM: 'on-zzim',
  OFF_ZZIM: 'off-zzim',
}
